import './App.css';
import{
  BrowserRouter,
  Routes,
  Route,
  // Link,
} from "react-router-dom"
import Home from './Components/Home';
import Menu from './Components/Menu';

import Aboutus from './Components/Aboutus';
import Contactus from './Components/Contactus';
import Travel from './Components/Travel';
import Health from './Components/Health';
import Car from './Components/Car';
import Bike from './Components/Bike';
import Life from './Components/Life';
import Cartracker from './Components/Cartracker';
import Productrisk from './Components/Productrisk';
import Claimsupport from './Components/Claimsupport';
import Car1 from './Components/Car1';
import Faq from './Components/Faq';
import Our from './Components/Our';
import Newform from './Components/Newform';
import Terms from './Components/Terms';
import Privacy from './Components/Privacy';
import Refund from './Components/Refund';

function App() {
  return(
  <>
  
  <BrowserRouter>
<Menu></Menu>
  <Routes>
    <Route path= "/" element= {<Home />} ></Route>
    <Route path= "/about" element= {<Aboutus />} ></Route>
    <Route path= "/contact" element= {<Contactus />} ></Route>
    <Route path= "/travel" element= {<Travel />} ></Route>
    <Route path= "/health" element= {<Health />} ></Route>
    <Route path= "/car" element= {<Car />} ></Route>
    <Route path= "/bike" element= {<Bike />} ></Route>
    <Route path= "/life" element= {<Life />} ></Route>
    <Route path= "/cartracker" element= {<Cartracker />} ></Route>
    <Route path= "/productrisk" element= {<Productrisk />} ></Route>
    <Route path= "/claimsupport" element= {<Claimsupport />} ></Route>
    <Route path= "/faq" element= {<Faq />} ></Route>
    <Route path= "/car1" element= {<Car1 />} ></Route>
    <Route path= "/Our" element= {<Our />} ></Route>
    <Route path= "/Newform" element= {<Newform />} ></Route>
    <Route path= "/Terms" element= {<Terms />} ></Route>
    <Route path= "/Privacy" element= {<Privacy />} ></Route>
    <Route path= "/Refund" element= {<Refund />} ></Route>


    






    







  </Routes>
  </BrowserRouter>
  </>
  
  );
 
}

export default App;
